<script>
  import {mapState, mapMutations, mapActions} from 'vuex';
  import InteractiveSearchMultiSelect from '@/components/shared_components/form_fields/InteractiveSearchMultiSelect';

  export default {
    extends: InteractiveSearchMultiSelect,
    computed: {
      ...mapState('PostingStore/BlockedSuppliersStore', {
        searchQuery: ({supplierSearchQuery}) => supplierSearchQuery
      })
    },
    methods: {
      ...mapActions({
        submitAction: 'PostingStore/BlockedSuppliersStore/searchSupplierByName',
        cancelSearch: 'PostingStore/BlockedSuppliersStore/cancelSearchInterpreters'
      }),
      ...mapMutations({
        setSearchQueryMutation: 'PostingStore/BlockedSuppliersStore/setSupplierSearchQuery'
      })
    }
  };
</script>
